import PageShell from "@/components/PageShell";
import PageHero from "@/components/PageHero";
import Storage from "@/components/Storage";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const USE_CASES = [
    "dApp metadata", "AI datasets", "Enterprise files",
    "App backups", "Decentralized hosting", "Sovereign storage",
];

const DASHBOARD = [
    { k: "Files Stored", v: "12,408" },
    { k: "Encrypted Shards", v: "198,528" },
    { k: "Storage Nodes", v: "3,142" },
    { k: "Proof Status", v: "All Verified" },
    { k: "Retrieval Health", v: "100%" },
    { k: "Redundancy Score", v: "98/100" },
    { k: "$DCX · 30d", v: "412.84 DCX" },
];

export default function StoragePage() {
    return (
        <PageShell>
            <PageHero
                eyebrow="Encrypted Storage"
                title="Encrypted Storage Without"
                accent="Trusting a Single Provider."
                sub="DeCloudX encrypts data client-side, splits it into erasure-coded fragments, distributes it across independent storage nodes, and verifies availability through on-chain Proof of Storage."
            />

            <Storage />

            <section className="relative py-16 md:py-24 border-t border-line">
                <div className="max-w-7xl mx-auto px-6 md:px-10">
                    <div className="grid lg:grid-cols-12 gap-10 items-start">
                        <div className="lg:col-span-5">
                            <div className="overline mb-3">Use Cases</div>
                            <h2 className="font-heading font-black text-2xl sm:text-3xl text-ink">Storage that fits enterprise and protocol needs.</h2>
                            <div className="mt-6 flex flex-wrap gap-2">
                                {USE_CASES.map((u, i) => <span key={i} className="chip">{u}</span>)}
                            </div>
                        </div>
                        <div className="lg:col-span-7 surface-strong rounded-2xl overflow-hidden" data-testid="storage-dashboard">
                            <div className="flex items-center justify-between px-6 py-4 border-b border-line bg-card-muted">
                                <div className="flex items-center gap-3">
                                    <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
                                    <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-ink">Storage Console · acct_dcx_84F</span>
                                </div>
                                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-faint-ink">Live</span>
                            </div>
                            <div className="grid grid-cols-2 md:grid-cols-3">
                                {DASHBOARD.map((d, i) => (
                                    <div key={i} className="p-5 border-r border-b border-line last:border-r-0">
                                        <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-faint-ink">{d.k}</div>
                                        <div className="font-heading font-bold text-lg text-ink mt-1.5">{d.v}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="mt-12">
                        <Link to="/contact?role=developer" className="btn-primary">Explore DeCloudX Storage <ArrowRight size={15} strokeWidth={2} /></Link>
                    </div>
                </div>
            </section>
        </PageShell>
    );
}
